<script setup lang="ts">
import { postPromoValidation } from '@caks/shared/api/user.route'
import { useAccountStore } from '@caks/shared/store/store.account'
import { Sale } from '@caks/shared/types/types.api'
import { isoToMonthDay } from '@caks/shared/utils/timeHelpers'
import { ButtonMain } from '@caks/uikit/button'

const store = useAccountStore()

interface Props {
  sale: Sale
}

const props = defineProps<Props>()
const errorText = ref('')

const onApply = async () => {
  const { data, status, message } = await postPromoValidation(props.sale.code)

  if (status === 'ERR') {
    errorText.value = message

    setTimeout(() => {
      errorText.value = ''
    }, 3000)

    return
  }

  store.setPromo(data)
}
</script>

<template>
  <article class="sale">
    <img class="sale__image" :src="sale.photo_desktop" alt="image" />
    <div class="sale__info info">
      <p class="info__date">До {{ isoToMonthDay(sale.end_at) }}</p>
      <p v-if="!errorText" class="info__text">{{ sale.description }}</p>
      <p v-else class="info__text info__text_error">{{ errorText }}</p>
      <ButtonMain :button-state="5" @click="onApply">Применить</ButtonMain>
    </div>
  </article>
</template>

<style scoped lang="scss">
.sale {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 304px;
  width: 304px;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px #00000012;
  overflow: hidden;
  padding-bottom: 16px;

  &__image {
    max-width: 100%;
    max-height: 208px;
    margin: 0 auto;
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;

    &__date {
      color: $sub-text;
      @include h5-2;
    }

    &__text {
      color: $primary-text;
      @include h3-5;

      &_error {
        color: $primary-red;
      }
    }
  }
}
</style>
